export default __webpack_public_path__ + "static/media/register.9686d566.svg";